<template>
  <b-row>
    <b-col cols="12">
      <b-form @submit.prevent>
        <b-form-group label="انتخاب بج" label-for="price-category-title-picker">
          <v-select
            :disabled="isDisabled"
            id="price-category-title-picker"
            dir="rtl"
            :filterable="false"
            v-if="badgeList"
            :reduce="(badge) => badge.id"
            v-model="selectedScheduleLoyaltyId"
            :options="badgeList"
            label="title"
            placeholder="بج را انتخاب کنید"
          >
            <template #no-options>هیچ بجی جهت نمایش وجود ندارد</template>
          </v-select>
        </b-form-group>
      </b-form>
    </b-col>
  </b-row>
</template>
<script>
export default {
  emits: ["getBadge"],
  props: {
    defaultScheduleLoyaltyTitleId: {
      type: [Number, String, Array],
      required: false,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    selectedScheduleLoyaltyId: {
      handler(val) {
        this.$emit("getBadge", val);
      },
    },
    defaultScheduleLoyaltyTitleId: {
      handler(val) {
        if (val && val != "" && val != 0) {
          this.getLiteScheduleLoyaltyTitle();
        }
      },
    },
  },
  mounted() {
    this.getLiteScheduleLoyaltyTitle();
  },
  data() {
    return {
      badgeList: null,
      selectedScheduleLoyaltyId: null,
      timeout: null,
    };
  },
  methods: {
    // handleSearch(searchValue, loadingFn) {
    //   if (this.timeout) {
    //     clearTimeout(this.timeout);
    //   }
    //   this.timeout = setTimeout(async () => {
    //     this.searchVal = searchValue;
    //     loadingFn(true);
    //     await this.getLiteScheduleLoyaltyTitle();
    //     loadingFn(false);
    //   }, 300);
    // },
    async getLiteScheduleLoyaltyTitle() {
      try {
        let qParams = {
          count: 10,
          pageNumber: 1,
        };
        // if (this.defaultCourseId) {
        //   qParams["courseId"] = this.defaultCourseId;
        // }
        // if (this.searchVal && this.searchVal != "") {
        //   qParams["searchCommand"] = this.searchVal;
        // }
        let _this = this;
        let getAllLoyaltyDiscountsLight = new GetAllLoyaltyDiscountsLight(
          _this
        );
        getAllLoyaltyDiscountsLight.setRequestParam(qParams);
        await getAllLoyaltyDiscountsLight.fetch((response) => {
          if (response) {
            _this.badgeList = response;
            if (_this.defaultScheduleLoyaltyTitleId) {
              _this.selectedScheduleLoyaltyId =
                _this.defaultScheduleLoyaltyTitleId;
            }
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    vSelect,
  },
};
import { BRow, BCol, BForm, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import { GetAllLoyaltyDiscountsLight } from "@/libs/Api/ScheduleLoyaltyDiscount";
</script>
